<i *ngIf="icon" [ngClass]="iconClasses">{{materialIcon}}</i>
